"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reviewTitleText = void 0;
var _ = require("./");
var reviewTitleText = function reviewTitleText(details) {
  var purpose = details.purpose,
    name = details.name,
    date = details.date;
  switch (purpose) {
    case _.RATING_REVIEW_PURPOSES.MONTHLY:
      return "Your experience with therapist ".concat(name);
    case _.RATING_REVIEW_PURPOSES.FIRST_CALL:
    case _.RATING_REVIEW_PURPOSES.FIRST_CLINICIAN_RATING:
      return "Appointment with ".concat(name, " on ").concat((0, _.formatDate)(date, {
        dateFormat: 'dddd, MMMM Do'
      }));
    case _.RATING_REVIEW_PURPOSES.GROUP:
      return "".concat(name, ", ").concat((0, _.formatDate)(date, {
        dateFormat: 'dddd, MMMM Do'
      }));
    default:
      return "Review for ".concat(name);
  }
};
exports.reviewTitleText = reviewTitleText;